import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// disable ServiceWorker
// import registerServiceWorker from './registerServiceWorker';


/*if (process.env.NODE_ENV === "development") {
    //console.log = () => {};
    console.log('INDEV')
  } else 
  */
  if (process.env.NODE_ENV === "production") {
    console.log('INPROD')
    // console.log = () => {};
    
  }
  

ReactDOM.render(<App />, document.getElementById('root'));
// disable ServiceWorker
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js